import React, { createContext, useCallback, useEffect, useState } from 'react'

import { useAuthState, useSocket, useUpdateUser } from 'hooks'
import { TIMESTAMP_KEYS } from 'constants/app'
import { EVENTS } from 'constants/socket'

const AppContext = createContext({})

const AppProvider = ({ children }) => {
  const { user } = useAuthState()
  const socket = useSocket('/users/me', !!user)
  const [features, setFeatures] = useState([])
  const [timestamps, setTimestamps] = useState({
    [TIMESTAMP_KEYS.PROFILE_COMPLETED]: 0,
    [TIMESTAMP_KEYS.PAYMENT_COMPLETED]: 0,
  })
  const { updateUserData } = useUpdateUser()

  useEffect(() => {
    if (!socket) {
      return
    }

    socket.on(EVENTS.FEATURES_UPDATE, data => setFeatures(data))

    socket.on(EVENTS.PROFILE_UPDATE, data => updateUserData(data))

    return () => socket.off(EVENTS.FEATURES_UPDATE, () => setFeatures([]))
  }, [socket, updateUserData])

  const updateTimestamp = useCallback((key, value) => {
    setTimestamps(prevState => ({
      ...prevState,
      [key]: value || Date.now(),
    }))
  }, [])

  return (
    <AppContext.Provider value={{ features, timestamps, updateTimestamp }}>
      {children}
    </AppContext.Provider>
  )
}

export { AppProvider, AppContext }
